module.exports = __webpack_public_path__ + "roundabout_sharp_right.svg?c9047ebe800c416075ccc5987cab5da6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_sharp_right.svg
// module id = 219
// module chunks = 0